export const DANGER = "DANGER"
export const INFO = "INFO"
export const WARNING = "WARNING"